import React from "react";
import { Box, Container, Flex, HStack, Link, SimpleGrid, Text } from "@chakra-ui/react";

const navigation = [
  { label: "Work", href: "/work" },
  { label: "Institute", href: "/institute" },
  { label: "Community", href: "/community" },
  { label: "Partner", href: "/partner" },
  { label: "About", href: "/about" },
  { label: "Resources", href: "/resources" },
];

function SiteFooter() {
  return (
    <Box
      as="footer"
      bg="#17211F"
      color="white"
      mt="auto"
    >
      <Container maxW="1400px" px={{ base: 5, md: 8, lg: 12 }} py={{ base: 14, md: 20 }}>
        <SimpleGrid
          columns={{ base: 1, md: 2, lg: 4 }}
          spacing={{ base: 10, lg: 16 }}
        >
          {/* Statement */}
          <Box gridColumn={{ lg: "span 2" }}>
            <Text
              fontFamily="'Poppins', sans-serif"
              fontSize={{ base: "lg", md: "xl" }}
              fontWeight="700"
              letterSpacing="-0.03em"
              mb={5}
            >
              SERENA SPACE
            </Text>

            <Text
              maxW="520px"
              fontSize={{ base: "md", md: "lg" }}
              lineHeight="1.7"
              color="whiteAlpha.700"
            >
              Building the scientific, technological and translational
              infrastructure needed to advance preventive and precision
              healthcare in Africa.
            </Text>
          </Box>

          {/* Explore */}
          <Box>
            <Text
              fontSize="xs"
              fontWeight="700"
              letterSpacing="0.12em"
              textTransform="uppercase"
              color="whiteAlpha.500"
              mb={5}
            >
              Explore
            </Text>

            <Flex direction="column" gap={3}>
              {navigation.map((item) => (
                <Link
                  key={item.href}
                  href={item.href}
                  fontSize="sm"
                  color="whiteAlpha.800"
                  _hover={{
                    color: "white",
                    textDecoration: "none",
                  }}
                >
                  {item.label}
                </Link>
              ))}
            </Flex>
          </Box>

          {/* Product */}
          <Box>
            <Text
              fontSize="xs"
              fontWeight="700"
              letterSpacing="0.12em"
              textTransform="uppercase"
              color="whiteAlpha.500"
              mb={5}
            >
              Health Technology
            </Text>

            <Link
              href="https://selense.serenaspace.com"
              isExternal
              fontSize="sm"
              color="whiteAlpha.800"
              _hover={{
                color: "white",
                textDecoration: "none",
              }}
            >
              Try Selense
            </Link>
          </Box>
        </SimpleGrid>

        <Box
          mt={{ base: 12, md: 16 }}
          pt={6}
          borderTop="1px solid"
          borderColor="whiteAlpha.200"
        >
          <Flex
            direction={{ base: "column", md: "row" }}
            justify="space-between"
            align={{ base: "flex-start", md: "center" }}
            gap={4}
          >
            <Text fontSize="xs" color="whiteAlpha.500">
              © {new Date().getFullYear()} Serena Space. All rights reserved.
            </Text>

            <HStack spacing={5}>
              <Link
                href="/privacy"
                fontSize="xs"
                color="whiteAlpha.500"
                _hover={{ color: "white", textDecoration: "none" }}
              >
                Privacy
              </Link>
            </HStack>
          </Flex>
        </Box>
      </Container>
    </Box>
  );
}

export default SiteFooter;